import jwtDecode from "jwt-decode";

const UseToken = () => {
    const token = window.localStorage?._tkn
    return token? jwtDecode(token) : null
}

const UseUserInfo = () => {
    return UseToken()?.userInfo
}

const IsSuperAdmin = () => {
    return UseToken()?.userInfo?.role?.slug === 'super-admin'
}

const IsAdmin = () => {
    return UseToken()?.userInfo?.role?.slug === 'admin'
}

export {UseToken, IsAdmin, IsSuperAdmin, UseUserInfo};